import { Environment } from "./Environment";
import { IOrgAssetsData } from "../interfaces/OrgAssets/IOrgAssetsData";
import { IOrgAssetAddRequest } from "../interfaces/OrgAssets/IOrgAssetAddRequest";
import { IOrgAssetUpdateRequest } from "../interfaces/OrgAssets/IOrgAssetUpdateRequest";
import { IOrgAssetRemoveRequest } from "../interfaces/OrgAssets/IOrgAssetRemoveRequest";
import { ErrorResponse } from "../interfaces/OrgAssets/ErrorResponse";
import { FetchProxy } from "intraactive-sdk-helper";
import { sdkContainerInstance } from "../global/Container";
import { IEnvironment } from "../interfaces/IEnvironment";
import { IOrgAssetGraphItem } from "../interfaces/OrgAssets/IOrgAssetGraphItem";

export default class OrgAssetsService {

  public static getOrgAssets(environment: IEnvironment, token: string, tenant: string): Promise<IOrgAssetsData> {
    return new Promise((resolve) => {
      if (environment && tenant && token) {
        const apiUrl = `${Environment.getEnvironmentForOrgAssetsAPI(environment)}/${tenant}`;
        new FetchProxy(apiUrl, { method: "GET", headers: { 'Content-Type': 'application/json', 'AuthToken': token } })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              return response.status;
            } else {
              return response.json();
            }
          }).then(response => {
            resolve(response);
          }).catch(error => {
            console.log(error);
          });
      } else {
        resolve(null);
      }
    });
  }

  public static addOrgAsset(environment: IEnvironment, token: string, tenant: string, addRequest: IOrgAssetAddRequest): Promise<void | ErrorResponse> {
    return new Promise((resolve) => {
      if (environment && tenant && token) {
        const apiUrl = `${Environment.getEnvironmentForOrgAssetsAPI(environment)}/${tenant}`;
        addRequest.libUrl.decodedUrl = this.ensureAbsoluteUrl(tenant, addRequest.libUrl.decodedUrl);
        if (addRequest.thumbnailUrl) {
          addRequest.thumbnailUrl.decodedUrl = this.ensureAbsoluteUrl(tenant, addRequest.thumbnailUrl.decodedUrl);
        }
        new FetchProxy(apiUrl, { method: "POST", headers: { 'Content-Type': 'application/json', 'AuthToken': token }, body: JSON.stringify(addRequest) })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            return response.json();
          }).then(response => {
            resolve(response);
          }).catch(error => {
            console.log(error);
          });
      } else {
        resolve(null);
      }
    });
  }

  public static updateOrgAsset(environment: IEnvironment, token: string, tenant: string, id: number, updateRequest: IOrgAssetUpdateRequest): Promise<void | ErrorResponse> {
    return new Promise((resolve) => {
      if (environment && tenant && token) {
        const apiUrl = `${Environment.getEnvironmentForOrgAssetsAPI(environment)}/${tenant}/${id}`;
        updateRequest.libUrl.decodedUrl = this.ensureAbsoluteUrl(tenant, updateRequest.libUrl.decodedUrl);
        if (updateRequest.thumbnailUrl) {
          updateRequest.thumbnailUrl.decodedUrl = this.ensureAbsoluteUrl(tenant, updateRequest.thumbnailUrl.decodedUrl);
        } else {
          updateRequest.thumbnailUrl = {
            decodedUrl: null
          };
        }
        new FetchProxy(apiUrl, { method: "PUT", headers: { 'Content-Type': 'application/json', 'AuthToken': token }, body: JSON.stringify(updateRequest) })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            return response.json();
          }).then(response => {
            resolve(response);
          }).catch(error => {
            console.log(error);
          });
      } else {
        resolve(null);
      }
    });
  }

  public static removeOrgAsset(environment: IEnvironment, token: string, tenant: string, id: number, removeRequest: IOrgAssetRemoveRequest): Promise<void | ErrorResponse> {
    return new Promise((resolve) => {
      if (environment && tenant && token) {
        const apiUrl = `${Environment.getEnvironmentForOrgAssetsAPI(environment)}/${tenant}/${id}`;
        removeRequest.libUrl.decodedUrl = this.ensureAbsoluteUrl(tenant, removeRequest.libUrl.decodedUrl);
        new FetchProxy(apiUrl, { method: "DELETE", headers: { 'Content-Type': 'application/json', 'AuthToken': token }, body: JSON.stringify(removeRequest) })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            return response.json();
          }).then(response => {
            resolve(response);
          }).catch(error => {
            console.log(error);
          });
      } else {
        resolve(null);
      }
    });
  }

  public static getFilesAndFoldersUsingGraph(environment: IEnvironment, tenant: string, site: string, orgAssetPath: string): Promise<IOrgAssetGraphItem[]> {
    return new Promise((resolve, reject) => {
      if (environment && tenant && site && orgAssetPath) {
        const apiUrl = `${Environment.getEnvironmentForOrgAssetsAPI(environment)}/${tenant}/${site}/path/${orgAssetPath}/graph/files`;
        new FetchProxy(apiUrl, {
          method: "GET",
          headers: { 'Content-Type': 'application/json' }
        })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            return response.json();
          }).then((response: IOrgAssetGraphItem[]) => {
            resolve(response);
          }).catch(error => {
            reject(error);
          });
      } else {
        reject();
      }
    });
  }

  public static getSubFolderFilesAndFoldersUsingGraph(environment: IEnvironment, tenant: string, site: string, orgAssetPath: string, subFolderId: string): Promise<IOrgAssetGraphItem[]> {
    return new Promise((resolve, reject) => {
      if (environment && tenant && site && orgAssetPath) {
        const apiUrl = `${Environment.getEnvironmentForOrgAssetsAPI(environment)}/${tenant}/${site}/path/${orgAssetPath}/${subFolderId}/graph/files`;
        new FetchProxy(apiUrl, {
          method: "GET",
          headers: { 'Content-Type': 'application/json' }
        })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            return response.json();
          }).then((response: IOrgAssetGraphItem[]) => {
            resolve(response);
          }).catch(error => {
            reject(error);
          });
      } else {
        reject();
      }
    });
  }

  private static ensureAbsoluteUrl(tenant: string, url: string): string {
    if (url && url.indexOf(`https://${tenant}.sharepoint.com`) === -1) {
      url = `https://${tenant}.sharepoint.com${url}`;
    }
    return url;
  }
}